export type SortType = "title" | "created_at" | "updated_at" | "last_accessed_at";

export const DEFAULT_SORT: SortType = "last_accessed_at";
export const DEFAULT_SORT_DESCENDING = true;
